import { useState } from 'react';

function submit(bookit, payload, config = {}) {
  return new Promise((resolve, reject) => {
    bookit.submit({
      MAType: 'Custom',
      formDataCollector: () => payload,
      afterSubmit: async (formData, responseData, hiddenFieldNames) => {
        resolve({ formData, responseData, hiddenFieldNames });
      },
      errorHandler: (error) => {
        reject(error);
      },
      ...config,
    });
  });
}

function redirect(bookit, options) {
  return bookit.redirect(options.responseData);
}

export function useBookit(config = {}) {
  let windowRef = {};
  if (typeof window !== 'undefined') {
    windowRef = window;
  }

  const scriptConfig = {
    calendaringObjectName: 'LDBookIt',
    orgId: process.env.NEXT_PUBLIC_BOOKIT_ORG_ID,
    nodeName: 'BookItDemo',
    useLocalStorage: false,
    options: { apiRoutingOn: true },
    ...config,
  };

  // If the function already exists it means we've already loaded it before and therefore we're ready
  const calendaringObjectIsSet =
    typeof windowRef[scriptConfig.calendaringObjectName] === 'function';

  const [ready, setReadyState] = useState(calendaringObjectIsSet);

  function onLoad() {
    setReadyState(true);
  }

  const bookit = windowRef[scriptConfig.calendaringObjectName];

  return {
    ready,
    onLoad,
    scriptConfig,
    bookit,
    submit(...args) {
      return submit(bookit, ...args);
    },
    redirect(...args) {
      return redirect(bookit, ...args);
    },
  };
}
